import { render, staticRenderFns } from "./PlannerIcon.vue?vue&type=template&id=0c8c8d87"
import script from "./PlannerIcon.vue?vue&type=script&lang=js"
export * from "./PlannerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports